import matter from "gray-matter";

const FRONT_MATTER = /^---\r?\n/;

const withoutFrontMatter = (text: string): string => {
	if (!FRONT_MATTER.test(text)) return text;
	try {
		return matter(text, {}).content.trim();
	} catch {
		return text;
	}
};

export default withoutFrontMatter;
